export var AgentWalletTransactionType;
(function (AgentWalletTransactionType) {
    AgentWalletTransactionType["RECHARGE"] = "recharge";
    AgentWalletTransactionType["REVOKE"] = "revoke";
    AgentWalletTransactionType["TRANSFER"] = "transfer";
    AgentWalletTransactionType["OUT"] = "out";
    AgentWalletTransactionType["IN"] = "in";
    AgentWalletTransactionType["DEPOSIT"] = "deposit";
    AgentWalletTransactionType["WITHDRAW"] = "withdraw";
    AgentWalletTransactionType["TOP_UP"] = "top_up";
    AgentWalletTransactionType["DEDUCT"] = "deduct";
    AgentWalletTransactionType["MANUAL_DEPOSIT"] = "manual_deposit";
})(AgentWalletTransactionType || (AgentWalletTransactionType = {}));
//# sourceMappingURL=AgentWalletTransactionType.js.map